import * as React from "react";
function SvgIcChevronSmallLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 7.375l-2.634 4.562L13.5 16.5l-.649.375L10 11.937 12.851 7l.649.375z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronSmallLeft;
